import { HeaderButtonProps } from "@omni/types/components/props/headerButton.props";
import { BaseStore } from "@omni/types/enums/baseStore.enum";
import { ReactElement } from "react";

import { HeaderButtonComponent } from "@/components/Navigation/Buttons/HeaderButton/headerButton.component";

type Props = HeaderButtonProps<BaseStore.Hubo> & {
    children?: ReactElement<{ closeCallback?: () => void }> | false | null;
};

export const HeaderButton = ({
    text,
    ariaLabel,
    hiddenText,
    icon,
    link,
    invert,
    invertMobile,
    showMenuOnHover,
    alerts,
    innerHTML,
    children
}: Props) => {
    const menuElement =
        children ||
        (innerHTML !== "" && innerHTML !== undefined && (
            <div
                dangerouslySetInnerHTML={{
                    __html: innerHTML
                }}
            />
        ));

    return (
        <HeaderButtonComponent
            text={text}
            ariaLabel={ariaLabel}
            hiddenText={hiddenText}
            icon={icon}
            link={link}
            invert={invert}
            invertMobile={invertMobile}
            showMenuOnHover={showMenuOnHover}
            alerts={alerts}
        >
            {menuElement}
        </HeaderButtonComponent>
    );
};
